import React from "react";

export const Privacy = () => {
  return (
    <>
      <h1>Privacy Policy for Rundoit</h1>

      <p>
        This Privacy Policy explains how Rundoit collects, uses, and protects
        information when you use our website, web application, and mobile
        application (together, the "Services").
      </p>

      <p>
        By using the Services, you agree to this Privacy Policy. If you have
        questions about privacy or would like to exercise a privacy right, you
        can contact us at <a href="mailto:smdar08@gmail.com">smdar08@gmail.com</a>.
      </p>

      <h2>Information we collect</h2>

      <p>Depending on how you use Rundoit, we may collect:</p>

      <ul>
        <li>
          Account information, such as your name, email address, and login
          details when you create an account or sign in with Google.
        </li>
        <li>
          Content you create in the app, including tasks, calendar items,
          onboarding selections, progress data, and feedback you choose to
          submit to us.
        </li>
        <li>
          Subscription and billing-related information needed to process paid
          plans. Card details are processed by Stripe and are not stored by
          Rundoit.
        </li>
        <li>
          Contact information and messages you send through our contact or
          feedback forms.
        </li>
        <li>
          Device, browser, app, and log information that may be collected by
          our hosting, analytics, authentication, database, and payment
          providers when you access the Services.
        </li>
      </ul>

      <h2>How we use information</h2>

      <p>We use personal information to:</p>

      <ul>
        <li>Provide, maintain, and improve the Services.</li>
        <li>Authenticate users and secure accounts.</li>
        <li>Save tasks, calendar items, and user preferences across devices.</li>
        <li>Process subscriptions, billing, and customer support requests.</li>
        <li>Communicate with you about your account, updates, and support.</li>
        <li>Detect abuse, fraud, bugs, and security issues.</li>
        <li>Comply with legal obligations and enforce our terms.</li>
      </ul>

      <h2>Third-party services</h2>

      <p>Rundoit relies on third-party providers to operate the Services.</p>

      <ul>
        <li>Firebase for authentication and data storage.</li>
        <li>Google for Google sign-in.</li>
        <li>Stripe for payment processing and subscription billing.</li>
      </ul>

      <p>
        These providers may process personal information in accordance with
        their own privacy policies and terms.
      </p>

      <h2>Cookies, local storage, and similar technologies</h2>

      <p>
        The website and web app may use cookies, browser storage, and similar
        technologies to keep you signed in, remember onboarding progress, and
        improve functionality. Mobile platforms may use equivalent on-device
        storage mechanisms.
      </p>

      <h2>How information is shared</h2>

      <p>We do not sell your personal information. We may share information:</p>

      <ul>
        <li>
          With service providers that help us run authentication, hosting,
          storage, support, and payments.
        </li>
        <li>
          When required by law, regulation, legal process, or valid government
          request.
        </li>
        <li>
          To protect the rights, safety, security, or property of Rundoit, our
          users, or others.
        </li>
        <li>
          As part of a merger, acquisition, financing, or sale of assets,
          subject to appropriate confidentiality protections.
        </li>
      </ul>

      <h2>Data retention</h2>

      <p>
        We retain information for as long as reasonably necessary to provide
        the Services, maintain business records, resolve disputes, meet legal
        requirements, and protect the security of the platform.
      </p>

      <h2>Your rights and choices</h2>

      <p>
        Depending on where you live, you may have the right to request access
        to, correction of, deletion of, or portability of your personal
        information, or to object to or limit certain processing. To make a
        request, contact us at{" "}
        <a href="mailto:smdar08@gmail.com">smdar08@gmail.com</a>.
      </p>

      <h2>Children's privacy</h2>

      <p>
        Rundoit is not intended for children under 13, and we do not knowingly
        collect personal information from children under 13. If you believe a
        child has provided personal information to us, please contact us so we
        can review and delete it where appropriate.
      </p>

      <h2>Security</h2>

      <p>
        We use reasonable administrative, technical, and organizational
        measures to protect personal information. However, no method of
        transmission over the internet or electronic storage is completely
        secure, so we cannot guarantee absolute security.
      </p>

      <h2>International use</h2>

      <p>
        Your information may be processed in countries other than your own,
        depending on where our providers operate their infrastructure.
      </p>

      <h2>Changes to this policy</h2>

      <p>
        We may update this Privacy Policy from time to time. When we do, we
        will post the updated version on this page and update the effective
        date below.
      </p>

      <p>
        <strong>Effective date:</strong> April 25, 2026
      </p>
    </>
  );
};
